"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setKiotaConfig = setKiotaConfig;
exports.getKiotaConfig = getKiotaConfig;
let config = {
    binaryLocation: "",
    binaryVersion: ""
};
function setKiotaConfig(newConfig) {
    config = { ...config, ...newConfig };
}
function getKiotaConfig() {
    return config;
}
//# sourceMappingURL=config.js.map